import { VariableType } from "../schema/VariableType";
import { BaseTypeSchema } from "../schema/BaseTypeSchema";
import { EnumSchema } from "../schema/type/EnumSchema";
import { ObjectSchema } from "../schema/type/ObjectSchema";

export abstract class BaseLooper 
{
    abstract getAll(callback: (schema: BaseTypeSchema) => void): BaseTypeSchema[];
    getAllByType<T extends BaseTypeSchema>(type: VariableType | null, callback: (schema: BaseTypeSchema) => void): T[]
    {
        let types: BaseTypeSchema[] = this.getAll(callback);
        if (type != null)
            types = types.filter(x => x.type == type);
        return types.map(t => t as T);
    }
    getObjects(have_name: boolean | null, callback: (schema: BaseTypeSchema) => void): ObjectSchema[]
    {
        let types = this.getAllByType<ObjectSchema>(VariableType.Object, callback);
        if (have_name != null)
        {
            if (have_name)
                types = types.filter(x => x.name);
            else
                types = types.filter(x => !x.name);
        }
        return types;
    }
    getEnums(callback: (schema: BaseTypeSchema) => void): EnumSchema[]
    {
        return this.getAllByType<EnumSchema>(VariableType.Enum, callback);
    }
}